import PropTypes from 'prop-types';
import React from 'react';
import { Question } from './Question';
import { DangerousHTMLDiv } from '../DangerousHTML/DangerousHTMLDiv';
import { RadioCheckboxOtherOption } from './RadioCheckboxOtherOption';

export class RadioCheckboxQuestion extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedListAnswerId: null,
    };
  }

  onRadioCheckboxChange = (event) => {
    this.onChange(parseInt(event.target.value, 10), '', event.target.checked);
  }

  onChange = (listAnswerId, otherOptionText, isChecked) => {
    this.setState({ selectedListAnswerId: listAnswerId });
    this.props.updateAnswer(
      this.props.questionnaireItem.questionnaireItemId,
      {
        listAnswerId,
        otherOptionText,
        isChecked,
      });

    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  render = () => {
    const { questionnaireItem, answerItem } = this.props;
    return (
    <div data-qa-item={this.props.inputType + '_question_type'} className="question-area">
      <Question questionNumber={questionnaireItem.questionNumber}
        isValid={ questionnaireItem.isValid }
        formattedText={questionnaireItem.formattedText}
        isRequired={questionnaireItem.isRequired}
      />
      <div className="form-group">
        { questionnaireItem.listAnswers.map((answer) => {
          if (answer.isOtherOption) {
            return (<RadioCheckboxOtherOption key={answer.listAnswerId}
              questionnaireItem={this.props.questionnaireItem} inputType={this.props.inputType}
              answer={answer} onChange={this.onChange}
              selectedListAnswerId={this.state.selectedListAnswerId}
              answerItem={answerItem}
              disabled={this.props.disabled}
            />);
          }
          return (
          <div key={answer.listAnswerId}>
            <div>
              <div className={'{0} inline-block hover-state'.replace('{0}', this.props.inputType)}>
                <label>
                  <input type={this.props.inputType} onChange={this.onRadioCheckboxChange}
                    name={'optionsRadioCheckbox' + questionnaireItem.questionnaireItemId}
                    value={answer.listAnswerId}
                    checked={answerItem && answerItem.some(x => x.listAnswerId === answer.listAnswerId)}
                    disabled={this.props.disabled}
                  />
                  <DangerousHTMLDiv html={answer.formattedText} />
                </label>
              </div>
            </div>
          </div>);
        })}
      </div>
    </div>);
  }
}

RadioCheckboxQuestion.propTypes = {
  questionnaireItem: PropTypes.object,
  updateAnswer: PropTypes.func,
  inputType: PropTypes.string,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
  answerItem: PropTypes.array,
};
